<template>
  <router-view />
</template>

<script>
import { call } from "vuex-pathify"

export default {
  name: "AdEditContainer",
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...call("ads", ["loadAdDraft"]),
  },
  beforeMount() {
    if (this.id) {
      this.loadAdDraft(this.id)
    }
  },
}
</script>
